'use strict';

import { axiosFactory } from '../common/axios-factory';
import { AJAX_PATH } from '../../constants';
import { isObject, isNil, isFunction, omitBy, debounce, has, forEach, keys, map } from 'lodash';

class Transmitter
{
    constructor()
    {
        // @var object
        this.questionsRefs = null;

        // @var Axios
        this.axios = null;

        // @var null | Object
        this.debouncedValues = null;

        // @var Vue
        this.bus = null;

        this.init();
    }

    init ()
    {
        this.axios = axiosFactory.get();
        this.sendLater = debounce(() =>
        {
            this.axios.post(`${AJAX_PATH}/answers`, {_method: 'PUT', answers: this.debouncedValues}).then(this.onSaveAnswer.bind(this)).catch(this.onError.bind(this));
            this.debouncedValues = null;
        }, 333);
    }

    setBus(bus)
    {
        this.bus = bus;
    }

    validateCurrentAnswers({ subsectionId })
    {
        setTimeout(() =>
        {
            this.axios.get(`${AJAX_PATH}/answers/${subsectionId}`).then((response) =>
            {
                if (this.bus)
                {
                    this.bus.$store.commit('SYNC_ANSWERS', [response.data]);
                }
            });
        }, 250);
    }

    getAdditionnalInfo(questionID)
    {
        if (questionID >= 1)
        {
            return this.axios.get(`${AJAX_PATH}/additional_info/${questionID}`);
        }
        return this.axios.get(`${AJAX_PATH}/guidelines-external-organizations/${questionID}`);
    }

    submitAnswer(uuKey, uuID, answer)
    {
        this.packageAnswer(uuKey, uuID, answer);
        this.sendLater();
    }

    packageAnswer(uuKey, uuID, answer)
    {
        // Remove any null values in object:
        if (isObject(answer))
        {
            answer = omitBy(answer, isNil)
        }

        const data = (isNil(answer)) ? JSON.stringify('') : JSON.stringify(answer);
        if (isNil(this.debouncedValues))
        {
            this.debouncedValues = {};
        }
        this.debouncedValues[uuKey] = {
            questionID: uuID,
            data
        };
    }

    loadContent(path, params)
    {
        const queryString = map(keys(params),(key) => `${key}=${params[key]}`).join('&');
        return this.axios.get(`${AJAX_PATH}/${path}?${queryString}`);
    }

    onError(error)
    {
        if (has(error, 'response') && has(error.response, 'data'))
        {
            if (error.response.data == 'KICKED-OUT')
            {
                window.location.reload(); // Let the back-end manage state
            }
        }
    }

    onSaveAnswer(response)
    {
        if (this.bus)
        {
            this.bus.$store.dispatch('UPDATE_COMPLETIONS', response.data.completions);
            if (has(response.data, 'scores'))
            {
                this.bus.$store.commit('UPDATE_DEBUGGER_SCORES', response.data.scores);
            }
        }
    }

    postFillSection(sectionNumber, answerSurveyId, onSuccessCallback)
    {
        this.axios.post(`${AJAX_PATH}/answers/post-fill/${sectionNumber}`, {_method: 'PUT', answerSurveyId}).then((response) =>
        {
            if (this.bus)
            {
                this.bus.$store.dispatch('HIDE_POSTFILL_BUTTON');
            }
            onSuccessCallback(response);
        });
    }

    submitDynamicRowProp([source, column, value, rowID], onSuccessCallback)
    {
        this.axios.post(`${AJAX_PATH}/dynamic-rows/col-value/${source}/${rowID}`, {_method: 'PUT', column, value}).then((response) =>
        {
            onSuccessCallback(response);
        });
    }

    submitDynamicRowLabel([source, label, rowID], onSuccessCallback)
    {
        this.axios.post(`${AJAX_PATH}/dynamic-rows/label/${source}/${rowID}`, {_method: 'PUT', label}).then((response) =>
        {
            onSuccessCallback(response);
        });
    }

    deleteDynamicRow([source, rowID], onSuccessCallback)
    {
        this.axios.post(`${AJAX_PATH}/dynamic-rows/${source}/${rowID}`, {_method: 'DELETE'}).then((response) =>
        {
            onSuccessCallback(response);
        });
    }

    addDynamicRow([source], onSuccessCallback)
    {
        this.axios.post(`${AJAX_PATH}/dynamic-rows/${source}`).then((response) =>
        {
            onSuccessCallback(response);

            setTimeout(() =>
            {
                $('.matrix-dynamic__input:empty').filter(function(){return this.value.length === 0}).eq(0).focus();
            }, 333);
        });
    }

    wipeAllDynamicRow([source], onSuccessCallback)
    {
        this.axios.post(`${AJAX_PATH}/dynamic-rows/${source}/all`, {_method: 'DELETE'}).then((response) =>
        {
            onSuccessCallback(response);
        });
    }

    allProvinceSelection(value, onSuccessCallback)
    {
        this.axios.post(`${AJAX_PATH}/all-province-selection`, {_method: 'PUT', value}).then((response) =>
        {
            if (isFunction(onSuccessCallback)) {
                onSuccessCallback(response);
            }
        });
    }

    fetch_from_province(onSuccessCallback)
    {
        this.axios.post(`${AJAX_PATH}/regions-in-province`, {_method: 'PUT'}).then((response) =>
        {
            onSuccessCallback(response);
        });
    }

    fetch_from_regions([codes], onSuccessCallback)
    {
        this.axios.post(`${AJAX_PATH}/counties-in-regions`, {_method: 'PUT', codes}).then((response) =>
        {
            onSuccessCallback(response);
        });
    }

    fetch_from_counties([codes], onSuccessCallback)
    {
        this.axios.post(`${AJAX_PATH}/municipalities-in-counties`, {_method: 'PUT', codes}).then((response) =>
        {
            onSuccessCallback(response);
        });
    }

    fetch_from_municipalities([codes], onSuccessCallback)
    {
        this.axios.post(`${AJAX_PATH}/municipalities-selection`, {_method: 'PUT', codes}).then((response) =>
        {
            onSuccessCallback(response);
        });
    }

    eraseSelection(sources)
    {
        forEach(sources, (source) =>
        {
            this.axios.get(`${AJAX_PATH}/erase-${source}-selection`);
        });
    }

}

const transmitter = new Transmitter();

export { transmitter }



// WEBPACK FOOTER //
// ./resources/assets/js/components/vuex/Transmitter.js